import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import axios from '@/utils/request';
import copy from 'lodash';
import smCrypto from "sm-crypto";

import ElementUI from 'element-ui'
import XTime from "@/components/x-time";

import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$copy = copy
Vue.prototype.$sm = smCrypto


Vue.use(ElementUI)
Vue.component('x-time', XTime)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
